module.exports = __webpack_public_path__ + "assets/header_logo.b75fa459.svg";